import { XMarkIcon, ChevronUpIcon } from '@heroicons/react/24/solid';
import classNames from 'classnames';
import { useMemo, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { cancelUpload, selectUploads } from './uploader-slice';
import styles from './uploader.module.css';
import { Upload, UploadStatus } from './uploader.types';
import { CHUNK_SIZE } from './uploader.consts';

export const Uploader = () => {
  const [isActive, setIsActive] = useState<boolean>(false);
  const uploads = useAppSelector(selectUploads);
  if (uploads.length === 0) return null;
  return (
    <div
      className={classNames(styles.uploader, {
        [styles.uploader__active]: isActive,
      })}
    >
      <div className={styles.uploader__title}>
        <span>
          Uploads {uploads.filter((u) => u.status === 'complete').length}/
          {uploads.length}
        </span>
        <ChevronUpIcon
          onClick={() => {
            setIsActive(!isActive);
          }}
        />
      </div>
      <div className={styles.uploader__uploads__container}>
        <ul className={styles.uploader__uploads}>
          {uploads.map((upload) => (
            <UploadItem upload={upload} key={upload._id} />
          ))}
        </ul>
      </div>
    </div>
  );
};

export const UploadItem = ({ upload }: { upload: Upload }) => {
  const dispatch = useAppDispatch();
  const url = useMemo(() => {
    return URL.createObjectURL(upload.file);
  }, [upload.file]);
  return (
    <li key={upload._id} className={styles.upload}>
      <div
        style={{
          backgroundImage: `url(${url})`,
        }}
        className={styles.preview}
      ></div>
      <div className={styles.upload__name}>{upload.file.name}</div>
      <div className={styles.upload__status}>{upload.status}</div>
      {upload.status === UploadStatus.Uploading && (
        <div className={styles.progress}>
          <progress
            max={Math.ceil(upload.file.size / CHUNK_SIZE)}
            value={upload.processedChunks}
          ></progress>
          <span>
            {Math.round(
              (upload.processedChunks /
                Math.ceil(upload.file.size / CHUNK_SIZE)) *
                100
            )}
            %
          </span>
        </div>
      )}
      <XMarkIcon
        onClick={() => {
          if (upload.status === UploadStatus.Complete) {
            dispatch(cancelUpload(upload._id));
          } else {
            // eslint-disable-next-line no-restricted-globals
            if (confirm('Are you sure you want to cancel this upload?')) {
              dispatch(cancelUpload(upload._id));
            }
          }
        }}
        className={styles.removeIcon}
      />
    </li>
  );
};
